import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix for default markers
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

// Custom marker icons
const createIcon = (color) => {
  return L.divIcon({
    className: 'custom-marker',
    html: `<div style="
      background-color: ${color};
      width: 24px;
      height: 24px;
      border-radius: 50% 50% 50% 0;
      transform: rotate(-45deg);
      border: 3px solid white;
      box-shadow: 0 2px 8px rgba(0,0,0,0.3);
    "></div>`,
    iconSize: [24, 24],
    iconAnchor: [12, 24],
    popupAnchor: [0, -24]
  });
};

const homeIcon = createIcon('#FF6B35');
const workIcon = createIcon('#004E89');
const otherIcon = createIcon('#28A745');

const getIcon = (type) => {
  switch (type) {
    case 'home': return homeIcon;
    case 'work': return workIcon;
    default: return otherIcon;
  }
};

const Map = ({ locations = [], center, zoom = 13, height = '400px', onMarkerClick }) => {
  // Default center to Bangalore if not provided
  const defaultCenter = center || (locations.length > 0
    ? [locations[0].coordinates.latitude, locations[0].coordinates.longitude]
    : [12.9716, 77.5946]);

  return (
    <div style={{ height, width: '100%', borderRadius: '12px', overflow: 'hidden' }}>
      <MapContainer
        center={defaultCenter}
        zoom={zoom}
        style={{ height: '100%', width: '100%' }}
        scrollWheelZoom={true}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        {locations.map((location) => (
          <Marker
            key={location._id}
            position={[location.coordinates.latitude, location.coordinates.longitude]}
            icon={getIcon(location.type)}
            eventHandlers={{
              click: () => onMarkerClick && onMarkerClick(location)
            }}
          >
            <Popup>
              <div style={{ minWidth: '150px' }}>
                <strong style={{ fontSize: '1rem' }}>{location.label}</strong>
                {location.isDefault && (
                  <span style={{
                    background: '#FF6B35',
                    color: 'white',
                    padding: '2px 6px',
                    borderRadius: '4px',
                    fontSize: '0.625rem',
                    marginLeft: '0.5rem'
                  }}>Default</span>
                )}
                <p style={{ margin: '0.5rem 0 0', fontSize: '0.875rem', color: '#666' }}>
                  {location.address?.full}
                </p>
                {location.address?.flatNumber && (
                  <p style={{ margin: '0.25rem 0 0', fontSize: '0.75rem', color: '#888' }}>
                    {location.address.building}, {location.address.flatNumber}
                  </p>
                )}
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default Map;
